<template>
  <PropertyComponentProvider>
    <div class="flex flex-1 flex-col overflow-x-hidden">
      <MTab v-model="currentTab" position="left">
        <MTabPane v-for="tab in allTabs" :key="tab.key" :tab="tab.title">
          <SummaryTab
            v-if="currentTab === 'summary'"
            :key="currentTab"
            :resource-id="resourceId"
            :resource="resource"
            :disabled="disabled"
            @refresh="$emit('refresh')"
          />
          <BaselineHistoryTab
            v-if="currentTab === 'baseline_history'"
            :key="currentTab"
            :disabled="disabled"
            :resource-id="resourceId"
          />
          <VarianceHistoryTab
            v-if="currentTab === 'variance_history'"
            :key="currentTab"
            :disabled="disabled"
            :resource-id="resourceId"
          />
        </MTabPane>
      </MTab>
    </div>
  </PropertyComponentProvider>
</template>
<script>
import PropertyComponentProvider from '@modules/asset/components/propery-component-list/property-component-provider'
import SummaryTab from './summary-tab/summary-tab'
import BaselineHistoryTab from './baseline-history-tab/baseline-history-tab'
import VarianceHistoryTab from './variance-history-tab/variance-history-tab'
export default {
  name: 'BaselineTab',
  components: {
    SummaryTab,
    BaselineHistoryTab,
    VarianceHistoryTab,
    PropertyComponentProvider,
  },
  props: {
    resourceId: { type: Number, required: true },
    resource: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      currentTab: 'summary',
      allTabs: [
        { title: this.$tc('summary'), key: 'summary' },
        {
          title: `${this.$tc('baseline')} ${this.$tc('history')}`,
          key: 'baseline_history',
        },
        {
          title: `${this.$tc('variance')} ${this.$tc('history')}`,
          key: 'variance_history',
        },
      ],
      // loading: true,
    }
  },
}
</script>
